"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/input-number/style/index.js
// module id = 105
// module chunks = 1